/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".container[_ngcontent-%COMP%]{height:500px;position:relative}.vertical-center[_ngcontent-%COMP%]{margin:0;position:absolute;top:50%;left:300px;transform:translateY(-50%)}.curr-pointer[_ngcontent-%COMP%]:hover{cursor:pointer}.card-body[_ngcontent-%COMP%]{background-color:#009b4c;color:#fff!important}.card-title1[_ngcontent-%COMP%]{font-weight:700;font-size:15px!important}"];
export { styles as styles };
